function countrySelector() {
  return {
    selectedCountry: null,
    languageData: {},
    showLanguageSelector: false,

    init() {
      // First set up the language data
      const languageDataRef = this.$refs.languageData;
      if (!languageDataRef) {
        console.error("Warning: languageData reference not found.");
        this.languageData = {};
        return;
      }

      try {
        this.languageData = JSON.parse(languageDataRef.textContent || "{}");
      } catch (error) {
        console.error("Error parsing language data:", error);
        this.languageData = {};
        return;
      }

      // Check if language selector is enabled
      const languageSelectRef = this.$refs.languageSelect;
      this.showLanguageSelector = Boolean(languageSelectRef);

      // Then update the languages based on the pre-selected country
      if (this.selectedCountry) {
        this.setLangs();
      }
    },

    setLangs() {
      if (!this.selectedCountry || !this.languageData[this.selectedCountry]) {
        return;
      }

      // Only try to update language select if it's enabled
      if (!this.showLanguageSelector) {
        return;
      }

      const languages = this.languageData[this.selectedCountry];
      const languageSelectRef = this.$refs.languageSelect;

      if (!languageSelectRef) {
        console.error("Warning: languageSelect reference not found.");
        return;
      }

      // Clear existing options
      languageSelectRef.innerHTML = "";

      // Populate language options
      languages.forEach((lang) => {
        const option = document.createElement("option");
        option.value = lang.iso_code;
        option.textContent = lang.endonym_name;
        languageSelectRef.appendChild(option);
      });

      // Set default selected language if available
      if (languages.length > 0) {
        languageSelectRef.value = languages[0].iso_code;
      }
    }
  };
}

export default countrySelector;
